// Pure validation for the native sign-up form, split out from useNativeAuth so it can be unit
// tested without rendering. Base requires E.164 when a phone is supplied and a min-8 password
// with confirmation; mirror that client-side so the field fails fast instead of round-tripping.
export const E164 = /^\+[1-9]\d{6,14}$/;

export type RegisterFieldErrors = Partial<
    Record<'first_name' | 'last_name' | 'email' | 'password' | 'phone' | 'general', string>
>;

export type RegisterValidationInput = {
    password: string;
    passwordConfirm: string;
    phone: string;
};

export type RegisterValidationMessages = {
    passwordTooShort: string;
    passwordsDoNotMatch: string;
    invalidPhoneFormat: string;
};

export function getRegisterValidationErrors(
    input: RegisterValidationInput,
    messages: RegisterValidationMessages,
): RegisterFieldErrors {
    const errors: RegisterFieldErrors = {};

    if (input.password.length < 8) errors.password = messages.passwordTooShort;
    else if (input.password !== input.passwordConfirm)
        errors.password = messages.passwordsDoNotMatch;

    // Phone is optional; only validate the format when something was typed.
    if (input.phone.trim() && !E164.test(input.phone.trim()))
        errors.phone = messages.invalidPhoneFormat;

    return errors;
}
